import { useCallback, useState } from 'react';
import { useLogin } from '../../../../hooks/useLogin';
import {
  isLoginResultSuccess,
  loginByEmail,
  LoginResult,
  loginByAuthorizationCode,
  loginByLegacyApiToken,
  deleteTokens,
} from '../../../../api/jwtAuth';
import { ApiTokenType } from '../../../../context/AuthContext';

export const useJwtAuth = () => {
  const [loginErrors, setLoginErrors] = useState<boolean>(false);
  const login = useLogin();

  const processLoginResult = useCallback(
    (loginResult: LoginResult) => {
      if (isLoginResultSuccess(loginResult)) {
        login(`Bearer ${loginResult.accessToken}`, ApiTokenType.JWT);
        return 'success';
      } else {
        setLoginErrors(true);
      }
    },
    [login],
  );

  const doLogin = useCallback(
    async (email: string, password: string) => {
      const loginResult = await loginByEmail(email, password);
      processLoginResult(loginResult);
    },
    [processLoginResult],
  );

  const doLoginByAuthorizationCode = useCallback(
    async (authorizationCode: string) => {
      await deleteTokens();
      const loginResult = await loginByAuthorizationCode(authorizationCode);
      processLoginResult(loginResult);
    },
    [processLoginResult],
  );

  const doLoginByLegacyApiToken = useCallback(
    async (apiToken: string) => {
      await deleteTokens();
      const loginResult = await loginByLegacyApiToken(apiToken);
      processLoginResult(loginResult);
    },
    [processLoginResult],
  );
  return {
    doLogin,
    doLoginByAuthorizationCode,
    doLoginByLegacyApiToken,
    loginErrors,
  };
};
